import { Action, Types } from "./templateTimeslotsChannel.actions"

export type TemplateTimeslotsChannelPayload = {
  template_id: number
}

export type TemplateTimeslotChannelState = {
  payload: TemplateTimeslotsChannelPayload | undefined
  connected: boolean
  errors: object
  connecting: boolean
}

const initialState: TemplateTimeslotChannelState = {
  payload: undefined,
  connected: false,
  errors: {},
  connecting: false,
}

export default (state = initialState, action: Action): TemplateTimeslotChannelState => {
  switch (action.type) {
    case Types.CONNECT:
      return {
        ...state,
        payload: action.payload,
        connecting: true,
      }

    case Types.CONNECTION_SUCCESS:
      return {
        ...state,
        connected: true,
        connecting: false,
      }

    case Types.CONNECTION_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    case Types.DISCONNECT:
      return {
        ...state,
        payload: undefined,
        connecting: false,
      }

    case Types.DISCONNECT_SUCCESS:
      return {
        ...state,
        connected: false,
        connecting: false,
      }

    case Types.DISCONNECT_FAILED:
      return {
        ...state,
        errors: action.payload.errors,
        connecting: false,
        connected: false,
      }

    default:
      return state
  }
}
